import { getSelectorRoot } from 'utils/selectors';

const getSocket = getSelectorRoot('socket');

export const getPartnerConfigs = getSocket('partnerConfigs');
export const getJackpots = getSocket('jackpots');
export const getIsConnected = getSocket('isConnected');
export const getReConnected = getSocket('reConnected');
